/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles'

import { Typography } from '@material-ui/core'

import { format, startOfYear,addQuarters, startOfQuarter, endOfQuarter ,isWithinInterval, isBefore, isAfter } from 'date-fns';

import HalfYearPicker from './components/HalfYearPicker';

class HalfYearRangePicker extends Component {
    state = {  }

    updateValue = (date, position) => {
        console.log("Selected Date :", date)
        let positioned_date

        if (position === 'start') {
            positioned_date = format(startOfQuarter(new Date(date)), "yyyy-MM-dd'T'HH:mm:ssxxx")
            this.props.update_filter('start_date', positioned_date)
        }

        if (position === 'end') {
            positioned_date = format(endOfQuarter(addQuarters(new Date(date), 1)), "yyyy-MM-dd'T'HH:mm:ssxxx")
            this.props.update_filter('end_date', positioned_date)
        }

        console.log("Positioned Quarter Date : ", positioned_date)
    }

    getMaxDate = () => {
        if (this.props.filter.start_date !== null) {
            let max_date = addQuarters(new Date(this.props.filter.start_date), 20)
            console.log("Max Date :", max_date)
            return max_date
        }
    }

    render() {
        return (
            <Fragment>
                <Typography style = {{marginLeft : '5px'}} variant = 'caption' color = 'secondary'><em>Maximum half yearly interval allowed is 12 half years</em></Typography>
                <div style = {{display : 'flex', flexDirection : 'row'}}>
                    <div style = {{margin : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>From</Typography>
                        <HalfYearPicker
                            date = {this.props.filter.start_date}
                            label = "Year"
                            helperText = "Choose the Year and Half Year"
                            onChange = {(value) => this.updateValue(value, "start")}
                        />
                    </div>
                    <div style = {{margin : '5px'}}>
                        <Typography variant = 'subtitle2' color = 'primary'>To</Typography>
                        <HalfYearPicker
                            date = {this.props.filter.end_date}
                            label = "Year"
                            maxDate = {this.getMaxDate()}
                            helperText = "Choose the Year and Half Year"
                            onChange = {(value) => this.updateValue(value, "end")}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default HalfYearRangePicker;